import SeoAuditDetail from './SeoAuditDetail.container';

export default SeoAuditDetail;
